import { Button, DrawerBody, DrawerHeader, Flex, Heading, Text, SimpleGrid, Link } from '@chakra-ui/react'
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Attachment } from 'components/icons'
import { useMapCoreManager } from '../../../../contexts/MapCoreManager/Provider'
import { getAfaCodeFormat } from 'modules/Geo/utils/afacode/getAfaCodeFormat'
import { INSTITUTION_SLUG } from 'constants/system'

export default function AFACodeDrawer() {
  const { selectedEntity } = useMapCoreManager()

  if (!selectedEntity) return <></>

  const data = selectedEntity?.data

  const mapLinks = [
    // {
    //   label: 'Plataforma Impacto',
    //   url: `https://brasil.cepdigital.org.br?afacode=${data?.logistic_id}`,
    //   colorScheme: 'primary',
    // },
    {
      label: 'Google Maps',
      url: `https://www.google.com/maps?q=${data.lat},${data.lon}`,
      colorScheme: 'yellow',
    },
    {
      label: 'Waze',
      url: `https://waze.com/ul?ll=${data.lat},${data.lon}&navigate=yes`,
      colorScheme: 'green',
    },
    {
      label: 'OpenStreetMap',
      url: `https://www.openstreetmap.org/?mlat=${data.lat}&mlon=${data.lon}#map=18/${data.lat}/${data.lon}`,
      colorScheme: 'teal',
    },
    {
      label: 'Apple Maps',
      url: `https://maps.apple.com/?ll=${data.lat},${data.lon}&z=18`,
      colorScheme: 'stone',
    },
  ]

  if (INSTITUTION_SLUG != 'mocambique') {
    mapLinks.push({
      label: 'AFA Codes',
      url: `https://cep.afa.codes/${data.logistic_id}`,
      colorScheme: 'blue',
    })
  }

  async function handleShare({ lat, lon, label }: { lat: number; lon: number; label?: string }) {
    const url = `https://www.google.com/maps?q=${lat},${lon}`

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Localização',
          text: label || 'Veja este local',
          url,
        })
      } catch (err) {
        console.error('Erro ao compartilhar:', err)
      }
    } else {
      // fallback (desktop ou browsers sem suporte)
      window.open(url, '_blank')
    }
  }

  return (
    <>
      <DrawerHeader>🌍 CEP Digital</DrawerHeader>
      <DrawerBody p={0}>
        <Flex
          bg="bgContent"
          alignItems={'center'}
          justifyContent={'center'}
          borderBottom={'1px solid'}
          borderColor={'borderColor'}
          h="100px"
        >
          <Heading size={'2xl'}>{getAfaCodeFormat(data?.logistic_id)}</Heading>
        </Flex>
        <Flex p={4}>
          <Flex flexDir={'column'} w="full" gap={4}>
            <Text variant={'secondary'}>COMPARTILHAMENTO</Text>
            <SimpleGrid columns={[1, 2, 2]} gap={2}>
              <Button
                size="lg"
                w="full"
                colorScheme={'primary'}
                rightIcon={<Attachment />}
                onClick={() => handleShare({ lat: data.lat, lon: data.lon, label: data?.logistic_id })}
                fontSize="md"
              >
                Compartilhar
              </Button>

              {mapLinks.map((link) => (
                <SharedButton key={link.url} link={link} />
              ))}
            </SimpleGrid>
          </Flex>
        </Flex>
      </DrawerBody>
    </>
  )
}

function SharedButton({ link }: { link: any }) {
  const handleMapLinkClick = (e: React.MouseEvent, url: string) => {
    e.stopPropagation() // Impede que o clique vaze para o mapa
    e.preventDefault() // Opcional: Evita comportamentos padrão se necessário
    window.open(url, '_blank', 'noopener,noreferrer') // Navega em nova aba
  }

  return (
    <Link
      key={link.label}
      href={link.url}
      w="full"
      isExternal
      _hover={{ textDecoration: 'none' }}
      onClick={(e) => handleMapLinkClick(e, link.url)} // ✅ Adicionado: Handler com stopPropagation
    >
      <Button size="lg" w="full" colorScheme={link.colorScheme} rightIcon={<ExternalLinkIcon />} fontSize="md">
        {link.label}
      </Button>
    </Link>
  )
}
